// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterDnDUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import { map, isEqual, isNil } from 'lodash/fp';
import { findDOMNode } from 'react-dom';
import CONSTANTS from 'logic/data/Izenda.ReportDesignerConstants';

function resetStyleItem(filterFields: any) {
  const listFilter = map(item => {
    if (item.filterItemDom) {
      const style = item.filterItemDom.style;
      style.borderLeftStyle = '';
      style.borderRightStyle = '';
    }
    return item.filterItemDom;
  }, filterFields);

  return listFilter;
}

function hover(props: any, monitor: any, component: any, position: any) {
  let cachedOffset = {};

  if (!monitor.canDrop()) {
    return;
  }

  const itemOffset = monitor.getClientOffset();
  const componentRect = findDOMNode(component).getBoundingClientRect();
  const itemWidth = componentRect.width / 4;
  const itemHeight = 50;

  const posItemX = itemOffset.x - componentRect.left;
  const posItemY = itemOffset.y - componentRect.top;

  if (isEqual(cachedOffset, itemOffset)) {
    return;
  }

  cachedOffset = itemOffset;

  if (posItemX > 0 && posItemY > 0 && posItemX < componentRect.width && posItemY < componentRect.height) {
    position.value = Math.floor(posItemX / itemWidth) + Math.floor(posItemY / itemHeight) * 4;
    let listFilter = resetStyleItem(component.props.store.reportFilters.displayFilterFields);

    // Update position if it is more than the last position
    if (listFilter.length && position.value >= listFilter.length) {
      position.value = listFilter.length;
    }

    // Set the style for the item at the position
    if (position.value === listFilter.length) {
      setStyleForItem(listFilter, position.value - 1, 'Right');
    } else {
      setStyleForItem(listFilter, position.value, 'Left');
    }
  }

  function setStyleForItem(listFilter: any, position: number, type: string) {
    if (isNil(listFilter[position])) return;
    listFilter[position].style['border' + type + 'Style'] = CONSTANTS.GENNERAL.BORDER_HOVER_ITEM.STYLE;
    listFilter[position].style['border' + type + 'Color'] = CONSTANTS.GENNERAL.BORDER_HOVER_ITEM.COLOR;
  }
}

export default {
  resetStyleItem,
  hover
};


// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.FilterDnDUtils.js